import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { datasetUrl } from '@/constants/urls';
import paging from '@/hooks/paging';
import { fetchDatasets } from '../actions';

const DatasetMenuItems = ({ datasets, fetchData, readStatus }) => {
  paging.useFetchByCategory(fetchData, 'ribbon', readStatus);
  return (
    datasets.map((dataset) => (
      <Dropdown.Item
        key={`datasets_menu_${dataset.code}`}
        as="a"
        href={datasetUrl(dataset, '#')}
        selected={false}
      >
        <Icon name="favorite" className="primary" />
        {dataset.catalogue.title}
      </Dropdown.Item>
    ))
  );
};

const mapStateToProps = ({
  datasets: {
    datasets,
  },
}, { category }) => {
  const { results, readStatus } = datasets[category];
  return ({ datasets: results, readStatus });
};

const mapDispatchToProps = {
  fetchData: fetchDatasets,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetMenuItems);
